import React, { Component } from "react";
import { View, StyleSheet, TouchableHighlight, Platform } from "react-native";
import Text from "../components_v2/TextFont";
import theme from "../argon-ui/Theme";
import { IS_MOBILE, translate } from "../locales/translate";
import FontAwesomeIcon from "../components_v2/FontAwesomeIcon";
import {
  faCheckSquare,
  faSquare,
  faEdit,
  faBatteryFull,
  faBatteryHalf,
  faBatteryQuarter,
  faBatteryThreeQuarters,
  faEyeSlash,
  faBlinds,
  faBlindsRaised,
  faCctv,
  faSensor,
  faFlashlight,
  faServer,
  faThermometerHalf,
  faExclamationTriangle,
  faSpeaker,
  faDoorOpen,
  faDoorClosed,
  faToggleOff,
  faToggleOn,
  faKey,
  faSortCircle,
  faChartPie,
  faSensorOn,
  faSensorAlert,
  faSensorFire,
  faTabletAndroidAlt,
  faDownload,
} from "../../assets/consts/faCharCodes";
import { WARNING_MIN_BATTERY } from "../../assets/consts";
// import { IconButton } from "../components_v2/Buttons";
import Theme from "../argon-ui/Theme";
import * as DeviceTypes from "../components/devices/_deviceTypes";
import Spinner from "../components_v2/Spinner";
import { HStack, IconButton, Badge, VStack } from "native-base";
class DeviceListItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      currentValue: this.props.deviceValue,
      showOnHomeScreen: this.props.showOnHomeScreen,
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (
      nextProps.deviceValue != prevState.currentValue &&
      prevState.isLoading
    ) {
      return { isLoading: false, currentValue: nextProps.deviceValue };
    }
    return null;
  }

  handleOnPress = () => {
    if (
      this.props.onPress &&
      this.props.deviceType !== DeviceTypes.TAPLIFE_CONTROLLER
    ) {
      // for time update controller)
      this.props.onPress();
    }
    this.setState({ isChecked: !this.state.isChecked });
  };

  handleOnLongPress = () => {
    if (
      this.props.onLongPress &&
      this.props.deviceType !== DeviceTypes.TAPLIFE_CONTROLLER
    ) {
      this.props.onLongPress();
    }
    this.setState({ isChecked: !this.state.isChecked });
  };

  handleOnTogglePress = (deviceId, currentValue) => {
    var newValue = !currentValue;
    this.props.onTogglePress && this.props.onTogglePress(deviceId, newValue);
    this.setState({ isLoading: true }, () => {
      setTimeout(() => {
        if (this.state.isLoading) {
          this.setState({ isLoading: false });
        }
      }, 5000);
    });
  };

  handleOnUnlockPress = (deviceId) => {
    this.props.onUnlockPress && this.props.onUnlockPress(deviceId);
  };

  renderIcon = () => {
    let _genericType = "Unknown";
    if (this.props.genericType) {
      _genericType = this.props.genericType;
    }

    if (this.props.isActive == false) {
      return (
        <IconContainer
          icon={faExclamationTriangle}
          color={Theme.COLORS.WARNING}
        />
      );
    }

    if (
      (_genericType == "SwitchBinary" || this.props.isGpio) &&
      this.props.deviceType != DeviceTypes.DOORLOCK &&
      !this.props.statusRelayId
    ) {
      return (
        <View
          style={{
            width: 45,
            height: 45,
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {this.state.isLoading ? (
            <Spinner size={26} />
          ) : (
            <IconButton
              onPress={() =>
                this.handleOnTogglePress(
                  this.props.deviceId || this.props.deviceUId,
                  this.props.deviceValue
                )
              }
              // style={{
              //   width: 45,
              //   height: 45,
              //   justifyContent: "center",
              //   borderRadius: 10,
              // }}
              style={[style.btnIcon, IS_MOBILE && style.bgBtnIcon]}
              icon={
                <FontAwesomeIcon
                  icon={this.props.deviceValue ? faToggleOn : faToggleOff}
                  size={16}
                  color={Theme.COLORS.BLACK}
                />
              }
            />
          )}
        </View>
      );
    } else if (
      _genericType == "SwitchBinary" &&
      !this.props.isGpio &&
      this.props.deviceType == DeviceTypes.DOORLOCK
    ) {
      return (
        <IconButton
          onPress={() =>
            this.handleOnUnlockPress(
              this.props.deviceId || this.props.deviceUId
            )
          }
          // style={{
          //   width: 45,
          //   height: 45,
          //   borderRadius: 10,
          // }}
          style={[style.btnIcon, IS_MOBILE && style.bgBtnIcon]}
          icon={
            <FontAwesomeIcon
              icon={faKey}
              size={16}
              color={Theme.COLORS.BLACK}
            />
          }
        />
      );
    }

    switch (this.props.deviceType) {
      case DeviceTypes.LIGHT:
        return (
          <View
            style={{
              width: 45,
              height: 45,
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {this.state.isLoading ? (
              <Spinner size={26} />
            ) : (
              <IconButton
                onPress={() =>
                  this.handleOnTogglePress(
                    this.props.deviceId || this.props.deviceUId,
                    this.props.deviceValue
                  )
                }
                // style={{
                //   width: 45,
                //   height: 45,
                //   justifyContent: "center",
                //   borderRadius: 10,
                // }}
                style={[style.btnIcon, IS_MOBILE && style.bgBtnIcon]}
                icon={
                  <FontAwesomeIcon
                    icon={this.props.deviceValue ? faToggleOn : faToggleOff}
                    size={16}
                    color={Theme.COLORS.BLACK}
                  />
                }
              />
            )}
          </View>
        );
      case DeviceTypes.ELEVATOR:
        return <IconContainer icon={faSortCircle} />;

      case DeviceTypes.DOOR_SENSOR:
        return (
          <IconContainer
            icon={this.props.deviceValue ? faDoorOpen : faDoorClosed}
          />
        );

      case DeviceTypes.CURTAIN:
        return (
          <IconContainer
            icon={this.props.deviceValue == 0 ? faBlindsRaised : faBlinds}
          />
        );

      case DeviceTypes.CAMERA:
        return <IconContainer icon={faCctv} />;
      case DeviceTypes.MOTION_SENSOR:
        return <IconContainer icon={faSensor} />;
      case DeviceTypes.LIGHT_METER:
        return <IconContainer icon={faFlashlight} />;
      case DeviceTypes.THERMO_METER:
        return <IconContainer icon={faThermometerHalf} />;
      case DeviceTypes.TAPLIFE_CONTROLLER:
        return <IconContainer icon={faServer} />;
      case DeviceTypes.SMART_SPEAKER:
        return <IconContainer icon={faSpeaker} />;
      case DeviceTypes.SENSOR_BINARY:
        return (
          <IconContainer
            icon={this.props.deviceValue ? faSensorOn : faSensor}
          />
        );
      case DeviceTypes.SMOKE_DETECTOR:
        return (
          <IconContainer
            icon={this.props.deviceValue ? faSensorFire : faSensor}
          />
        );
      case DeviceTypes.LEAK_DETECTOR:
        return (
          <IconContainer
            icon={this.props.deviceValue ? faSensorAlert : faSensor}
          />
        );
      case DeviceTypes.TOUCH_PANEL:
        return <IconContainer icon={faTabletAndroidAlt} />;
      default:
        break;
    }
  };

  render() {
    let _genericType = "Unknown";
    if (this.props.genericType) {
      _genericType = this.props.genericType;
    }
    return (
      <HStack
        space="2"
        alignItems="center"
        style={[
          {
            borderRadius: 5,
            marginBottom: 5,
            backgroundColor: Theme.COLORS.WHITE,
            minHeight: 65,
            padding: 10,
          },
          this.props.styleContainer || {},
        ]}
      >
        <View style={{ width: 45, alignItems: "center" }}>
          <View style={{ justifyContent: "center", alignItems: "center" }}>
            {this.renderIcon()}
          </View>
          {this.props.batteryLevel != undefined && (
            <View
              style={{
                width: 25,
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <FontAwesomeIcon
                icon={
                  this.props.batteryLevel > 75
                    ? faBatteryFull
                    : this.props.batteryLevel > 50
                    ? faBatteryThreeQuarters
                    : this.props.batteryLevel > 25
                    ? faBatteryHalf
                    : faBatteryQuarter
                }
                color={
                  this.props.batteryLevel > WARNING_MIN_BATTERY
                    ? Theme.COLORS.SUCCESS
                    : Theme.COLORS.ERROR
                }
                size={14}
              />
              <Text
                style={[
                  style.iosRtl,
                  {
                    fontSize: 9,
                    color:
                      this.props.batteryLevel > WARNING_MIN_BATTERY
                        ? Theme.COLORS.SUCCESS
                        : Theme.COLORS.ERROR,
                  },
                ]}
              >
                {this.props.batteryLevel}%
              </Text>
            </View>
          )}
        </View>
        <View
          style={{
            flex: 1,
          }}
        >
          <TouchableHighlight
            underlayColor="#eee"
            style={[style.touchable, { flex: 1 }]}
            // delayLongPress={1200}
            onLongPress={this.handleOnLongPress}
            onPress={this.handleOnPress}
          >
            <View
              style={{
                flex: 1,
                flexDirection: "row",
                justifyContent: "space-between",
                width: "100%",
                alignItems: "center",
              }}
            >
              <View style={{ flex: 1, alignItems: "flex-start" }}>
                <Text style={[style.iosRtl, { fontSize: 12 }]}>
                  {this.props.deviceType &&
                    translate("deviceGroup." + this.props.deviceType) + ": "}
                  {this.props.deviceName || this.props.name}
                </Text>
                {this.props.deviceCode != undefined &&
                  this.props.deviceCode.length > 0 && (
                    <Text
                      style={[
                        style.iosRtl,
                        {
                          color: Theme.COLORS.MUTED,
                          fontSize: 10,
                        },
                      ]}
                    >
                      {translate("device.deviceCode")}: {this.props.deviceCode}
                    </Text>
                  )}
                {/* {this.props.updateDeviceAvailable && (
                  <VStack space="1" mt="2">
                    {this.props.updateDeviceAvailable.version && (
                      <Text style={{ fontSize: 10 }}>
                        {translate(`device.updateDevice.version`, {
                          version: this.props.updateDeviceAvailable.version,
                        })}
                      </Text>
                    )}
                    {this.props.updateDeviceAvailable.updateAvailable && (
                      <TouchableHighlight
                        underlayColor="transparent"
                        onPress={() => {
                          // === TODO
                          if (this.props.onPressUpdateController) {
                            // === For Just DownLoad ===
                            if (
                              this.props.updateDeviceAvailable.updateStatus ==
                              "ReadyToDownload"
                            ) {
                              this.props.onPressUpdateController("download");

                              // === For Just DownLoad and install ===
                            } else if (
                              this.props.updateDeviceAvailable.updateStatus ==
                              "ReadyToInstall"
                            ) {
                              this.props.onPressUpdateController("install");
                            }
                            {
                            }
                          }
                        }}
                        style={{
                          shadowColor: Theme.COLORS.SUCCESS,
                          shadowOffset: {
                            width: 0,
                            height: 3,
                          },
                          shadowOpacity: 0.2,
                          shadowRadius: 6.65,
                          elevation: 4,
                        }}
                      >
                        <Badge colorScheme="success">
                          <HStack space="1.5" alignItems="center">
                            {this.props.updateDeviceAvailable.updateStatus ==
                              "Downloading" ||
                            this.props.updateDeviceAvailable.updateStatus ==
                              "Installing" ? (
                              <>
                                <Spinner
                                  size={12}
                                  containerStyle={{ width: 12, height: 12 }}
                                />
                                <Text style={{ fontSize: 11, flex: 1 }}>
                                  {translate(
                                    `device.updateDevice.${this.props.updateDeviceAvailable.updateStatus}`
                                  )}
                                </Text>
                              </>
                            ) : (
                              <>
                                <FontAwesomeIcon
                                  icon={faDownload}
                                  color={theme.COLORS.BLACK}
                                  size={12}
                                />
                                <Text style={{ fontSize: 11 }}>
                                  {translate(
                                    `device.updateDevice.getNextVersion`,
                                    {
                                      nextVersion:
                                        this.props.updateDeviceAvailable
                                          .nextVersion,
                                    }
                                  )}
                                </Text>
                              </>
                            )}
                          </HStack>
                        </Badge>
                      </TouchableHighlight>
                    )}
                  </VStack>
                )} */}
              </View>

              {!this.props.showOnHomeScreen && (
                <View
                  style={{
                    width: 30,
                    flexDirection: "row",
                    alignItems: "flex-start",
                    // paddingStart: 12,
                    paddingTop: 4,
                  }}
                >
                  <FontAwesomeIcon
                    icon={faEyeSlash}
                    color={theme.COLORS.MUTED}
                    size={14}
                  />
                </View>
              )}
              <View style={{ justifyContent: "center" }}>
                {this.props.showCheckbox && (
                  <FontAwesomeIcon
                    icon={this.props.isChecked ? faCheckSquare : faSquare}
                    color={theme.COLORS.PRIMARY}
                    size={26}
                    style={{ marginLeft: 5 }}
                  />
                )}
                <HStack space="2">
                  {!this.props.showCheckbox &&
                    this.props.deviceType !==
                      DeviceTypes.TAPLIFE_CONTROLLER && (
                      <IconButton
                        variant="ghost"
                        style={[style.btnIcon, IS_MOBILE && style.bgBtnIcon]}
                        onPress={() =>
                          typeof this.props.goToDeviceLog === "function" &&
                          this.props.goToDeviceLog()
                        }
                        icon={
                          <FontAwesomeIcon
                            icon={faChartPie}
                            color={theme.COLORS.MUTED}
                            size={20}
                          />
                        }
                      />
                    )}

                  {!this.props.showCheckbox && (
                    <IconButton
                      variant="ghost"
                      style={[style.btnIcon, IS_MOBILE && style.bgBtnIcon]}
                      onPress={this.handleOnPress}
                      // onPress={() => {
                      //   if (
                      //     this.props.updateDeviceAvailable &&
                      //     this.props.onPressUpdateController
                      //   ) {
                      //     // === For edit device controller ===
                      //     this.props.onPressUpdateController();
                      //   } else {
                      //     // === For edit order device ===
                      //     this.handleOnPress;
                      //   }
                      // }}
                      icon={
                        <FontAwesomeIcon
                          icon={faEdit}
                          color={theme.COLORS.MUTED}
                          size={20}
                        />
                      }
                    />
                  )}
                </HStack>
              </View>
            </View>
          </TouchableHighlight>
        </View>
      </HStack>
    );
  }
}
const IconContainer = ({ icon, color = Theme.COLORS.MUTED }) => {
  return (
    <View
      style={{
        width: 30,
        height: 30,
        borderRadius: 10,
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <FontAwesomeIcon icon={icon} size={16} color={color} />
    </View>
  );
};
const style = StyleSheet.create({
  touchable: {
    // padding: 10,
    alignItems: "center",
    height: 58,
    borderRadius: 5,
  },
  iosRtl: {
    textAlign: Platform.OS == "ios" ? "left" : "auto",
  },
  bgBtnIcon: {
    backgroundColor: Theme.COLORS.WHITE,
  },
  btnIcon: {
    borderRadius: 10,
    padding: 0,
    width: 45,
    height: 45,
    // shadowColor: Theme.COLORS.INPUT,
    // shadowOffset: {
    //   width: 0,
    //   height: 6,
    // },
    // shadowOpacity: 0.3,
    // shadowRadius: 6.65,
    // elevation: 9,
    shadowColor: Theme.COLORS.MUTED,
    shadowOffset: {
      width: 0,
      height: 3,
    },
    shadowOpacity: 0.2,
    shadowRadius: 6.65,
    elevation: 4,
  },
});

export default DeviceListItem;
